import { useNavigate } from "react-router-dom";
import { Routes } from "@/types/routes";
import { useCallback } from "react";

const useNavigateToStart = () => {
  const navigate = useNavigate();

  return useCallback(() => {
    const returnUrl = sessionStorage.getItem("returnUrl");
    sessionStorage.removeItem("returnUrl");
    if (returnUrl) return window.location.replace(returnUrl);
    navigate(Routes.START);
  }, [navigate]);
};

export default useNavigateToStart;
